import { render } from "./ApplyPage.vue?vue&type=template&id=5664cab2"
import script from "./ApplyPage.vue?vue&type=script&lang=js"
export * from "./ApplyPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__